import { Coord, GridConfig } from "../../../../../../../src/types/Interface";


export default function genRandomStartPoint(gridConfig: GridConfig, offsets: number[]): Coord {
  const u = gridConfig.width / gridConfig.cellSize - offsets[2];
  const v = gridConfig.height / gridConfig.cellSize - offsets[3];

  return {
    x: Math.floor(Math.random() * u) + offsets[0],
    y: Math.floor(Math.random() * v) + offsets[1]
  };


}